import { useContext } from 'react';
import { DashboardContext } from '@/common/contexts/dashboard-context';

export function useDashboardContext() {
  const context = useContext(DashboardContext);
  if (context === undefined) {
    throw new Error('useDashboardContext must be used within a DashboardProvider');
  }
  return context;
}
